// App.js
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
// import Animation from "./components/Animation";
import ScrollSection from "./components/ScrollSection";
import SeoServicesSection from "./components/SeoServicesSection";
import CaseStudy from "./components/Casestudy";
import Card from "./components/Card";
import SEOWorkflow from "./components/SEOWorkflow";
import Industry from "./components/Industries";
import Feedback from "./components/FeedBack";
// import Feature from "./components/Feature";
// import Speciallist from "./components/Speciallist";
// import Faq from "./components/Faq";
// import Weastingmoney from './components/Wastingmoney';
import About from "./components/About";
import AboutEffectBox from "./components/AboutEffectBox";
import { Element } from "react-scroll";
import { Route, Routes, useLocation } from "react-router-dom";
import Service from "./components/Service_section/Service";
import { useEffect } from "react";
import { scroller } from "react-scroll";
import Locations from "./components/Location";
import { useNavigation } from "./Context/NavigationContext";
import ScrollToTop from "./components/ScrollToTop";

function App() {

   const { scrollTarget, setScrollTarget } = useNavigation();
  const location = useLocation();
  
  useEffect(() => {
    if (location.pathname === "/" && scrollTarget) {
      scroller.scrollTo(scrollTarget, {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -80,
      });
      setScrollTarget(null); // Clear after scrolling
    }
  }, [location.pathname, scrollTarget]);


  return (
    <div className="App">
        

      {/* <section>
        <Animation />
      </section> */}
      {/* <section>
        <Feature />
      </section> */}
      {/* <section>
        <Speciallist />
      </section> */}
      {/* <section>
        <Faq />
      </section> */}
       
    <Routes>
      <Route path="/" element={
        <>
         <Element name="home">
          <Header />
          <HeroSection />
            </Element>        
          <Element name="about">
            <AboutEffectBox />
          </Element>
            <ScrollSection />
          <Element name="services">
            <SeoServicesSection />
          </Element>
          <Element name="workflow">
            <SEOWorkflow />
          </Element>
          <Element name="products">
            <CaseStudy />
            <Card />
            </Element>
            <Element name="industries">
               <Industry />
            </Element>
                {/* <Element name="feedback">
              <Feedback />
              </Element> */}
            <Element name="locations">
              <Locations/>
            </Element>
              <Element name="contact">
                <About />
              </Element>
          
        </>
      } />
  <Route path="/service" element={<Service/>} />
</Routes>

<ScrollToTop/>
    </div>
    
  );
}

export default App;
